import { AppBar } from '@material-ui/core';
import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';

import Topbar from './components/Topbar';
import NewTicketForm from './components/NewTicketForm';

function App() {
  const [date, setDate] = useState(null);
  useEffect(() => {
    async function getDate() {
      const res = await fetch('/api/date');
      const newDate = await res.text();
      setDate(newDate);
    }
    getDate();
  }, []);
  return (
    <main>
      <Topbar />
      <NewTicketForm />
    </main>
  );
}

export default App;
